import request from '../utils/request'
import request2 from '../utils/request_2'

/*
    供货商商品管理列表
*/
export function productList(data) {
    return request({
        url: '/product/productList',
        method: 'POST',
        data,
    })
}

/*
    供货商 /销售商订单管理列表
*/
export function orderList(data) {
    return request({
        url: '/dwOrder/orderList',
        method: 'POST',
        data,
    })
}

/*
    供应商添加商品
*/
export function addProduct(data) {
    return request({
        url: '/commodity/addProduct',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交中...'
    })
}

/*
    供应商商品列表
*/
export function mallItemList(data) {
    return request({
        url: '/commodity/newMallItemList', // /commodity/mallItemList
        method: 'POST',
        data,
    })
}

/*
    供应商商品上下架及删除功能
*/
export function updateItemState(data) {
    return request({
        url: '/commodity/updateItemState',
        method: 'POST',
        data,
    })
}

/*
    供应商商品详情
*/
export function getMallItemInfo(data) {
    return request({
        url: '/commodity/getMallItemInfo',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    供应商编辑商品
*/
export function editMallItemInfo(data) {
    return request({
        url: '/commodity/editMallItemInfo',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交中...'
    })
}

/*
    供应商库存列表
*/
export function getStockList(data) {
    return request({
        url: '/commodity/getStockList',
        method: 'POST',
        data,
    })
}

/*
   供应商修改库存
*/
export function editStock(data) {
    return request({
        url: '/commodity/editStock',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交...'
    })
}

/*
    供应商添加商品获取品牌
*/
export function brandListByUser(data) {
    return request({
        url: '/commodity/brandListByUser',
        method: 'POST',
        data,
    })
}

/*
    供应商个人设置添加品牌
*/
export function addBrand(data) {
    return request({
        url: '/commodity/addBrand',
        method: 'POST',
        data,
    })
}
    
//销售商锁仓
export function reserveOrder(data) {
    return request({
        url: '/dwOrder/reserveOrder',
        method: 'POST',
        loading:true,
        data,
    })
}
// 取消锁仓
export function updateReserverOrderState(data) {
    return request({
        url: 'dwOrder/updateReserverOrderState',
        method: 'POST',
        loading:true,
        data,
    })
}
// orderId：订单列表的orderId，唯一标识
// reserveOrderNumber：锁仓订单号
// orderState： 1=（同意锁仓）0=（拒绝锁仓）3=（供应商审核超时）2=（默认为待供应商审核）
// orderLastUpdateMemo：拒绝理由




//获取商品下的锁仓订单列表 //0为无效（销售商取消），，默认2为待供应商审核，3为供应商审核超时，4为供应商拒绝 1为有效（供应商同意）
export function getOrderLockList(data) {
    return request({
        url: '/dwOrder/getOrderReserveInfo',
        method: 'POST',
        loading:true,
        data,
    })
}
// 销售商 商品下载
export function exportItemInfo(data) {
    return request({
        url: '/export/exportItemInfo',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}


/*
    下载商品表格 (Updated on 2020.7.27  by chao)
*/
// 销售商
export function exportMallList(data) {
    return request2({
        url: '/?s=item&op=export',
        method: 'POST',
        data,
        timeout: 0,
        loading: true,
        loadingText: '正在生成下载链接...',
        noAuth: true,
    })
}

// 销售商 下单 -有锁仓单时下单
export function orderPurchase(data) {
    return request({
        url: '/dwOrder/orderPurchase',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}
// 销售商 下单 -无锁仓单时下单
export function noLockOrderPurchase(data) {
    return request({
        url: '/dwOrder/noLockOrderPurchase',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}
// 销售商 核销
export function saveOrderEstablish(data) {
    return request({
        url: '/dwOrder/saveOrderEstablish',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}
// 销售商 付款弹窗:填写金额及上传凭证
export function saveOrderPayment(data) {
    return request({
        url: '/dwOrder/saveOrderPayment',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}
// 销售商 付款弹窗:清算后最后一次付款
export function saveOrderPaymentByliquidate(data) {
    return request({
        url: '/dwOrder/saveOrderPaymentByliquidate',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}

// 销售商 退货数量弹窗
export function returnGoods(data) {
    return request({
        url: '/dwOrder/returnGoods',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}
// 退货数量详情
export function returnGoodInfo(data) {
    return request({
        url: '/dwOrder/returnGoodInfo',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}
// 总下单数和累计核销数
export function returnGoodsInfo(data) {
    return request({
        url: '/dwOrder/returnGoodsInfo',
        method: 'POST',
        timeout: 0,
        loading:true,
        data,
    })
}


// 重构以后的接口
/*
    获取锁仓列表
*/
export function reserverOrderList(data) {
    return request({
        url: '/dwOrder/reserverOrderList',
        method: 'POST',
        data,
    })
}
/*
    供应商销售商锁仓单详情
*/
export function getOrderReserveInfo(data) {
    return request({
        url: '/dwOrder/getOrderReserveInfo',
        method: 'POST',
        data,
        loading: true
    })
}
export function getOrderPurchaseList(data) { //清算获取符合要求的下单列表
    return request({
        url: '/dwOrder/getOrderPurchaseList',
        method: 'POST',
        data,
        loading: true
    })
}
/*
    获取下单列表
*/
export function getPurchaseList(data) {
    return request({
        url: '/dwOrder/getPurchaseList',
        method: 'POST',
        data,
    })
}

/*
    获取清算列表
*/
export function getLiquidateList(data) {
    return request({
        url: '/dwOrder/getLiquidateList',
        method: 'POST',
        data,
    })
}
/*
    发起清算操作
*/
export function launchLiquidate(data) {
    return request({
        url: '/dwOrder/launchLiquidate',
        method: 'POST',
        data,
    })
}
// 给销售商发账单
export function sendBillInfo(data) {
    return request({
        url: '/dwOrder/sendBillInfo',
        method: 'POST',
        data,
    })
}
// 清算前，检查有没有付款没有确认的
export function checkPaymentStatus(data) {
    return request({
        url: '/dwOrder/checkPaymentStatus',
        method: 'POST',
        data,
    })
}


// 销售商申请平台向自己打款
export function saveRequestInfo(data) {
    return request({
        url: '/dwOrder/saveRequestInfo',
        method: 'POST',
        data,
    })
}
// 销售商申请记录
export function applicationList(data) {
    return request({
        url: '/dwOrder/applicationList',
        method: 'POST',
        data,
    })
}
// 销售商申请 确认平台付款
export function confirmRequestPayment(data) {
    return request({
        url: '/dwOrder/confirmRequestPayment',
        method: 'POST',
        data,
    })
}
// 销售商申请 确认平台付款-清算
export function confirmRequestPaymentByOrder(data) {
    return request({
        url: '/dwOrder/confirmRequestPaymentByOrder',
        method: 'POST',
        data,
    })
}








